<template lang="pug">
    div.widget.pb-2
        div.content
            v-tooltip(
                top
                max-width="220"
            )
                template(v-slot:activator="{ on }")
                    div.counter(v-on="on")
                        div.digit {{ counter | numberWithCommas }}

                div.tooltipInner {{ content.tooltip }}

            div.description
                div.icon
                    v-icon {{ content.icon }}
                div.descriptionText(v-if="showHours") {{ content.descriptionHours  }}
                div.descriptionText(v-else) {{ content.description }}
</template>

<script>
    import VueTypes from 'vue-types';
    import numberWithCommas from '~filters/numberWithCommas';

    export default {
        filters: { numberWithCommas },
        props: {
            content: VueTypes.object.def({}),
            showHours: VueTypes.bool.def(false),
            counter: VueTypes.number.def(0)
        },
        computed: {
            digitsArray() {
                return this.$options.filters
                    .numberWithCommas(this.counter)
                    .split('');
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .widget
        text-align: center
        width: 100%

        &.sameHeight
            height: 100%

    .content
        border-radius: 10px
        height: 100%

    .counter
        display: inline-block

    .digit
        display: inline-block
        padding: 0 4px 2px
        margin: 3px
        background-color: $theme.primary
        font-size: remify(42px)
        font-weight: 300
        line-height: 1
        user-select: none
        letter-spacing: 2px;

    .description
        display: flex
        align-items: center
        justify-content: center
        margin-top: 15px

    .icon
        width: 28px
        height: 28px
        margin-right: 10px
        border-radius: 28px
        background-color: rgba(255, 255, 255, 0.2)
        text-align: center
        line-height: 1

        i
            color: $theme.white
            font-size: 22px
            margin-top: 3px

    .descriptionText
        text-transform: uppercase
        font-size: remify(14px)
        font-weight: 300

    .longText .descriptionText
        font-size: remify(15px)

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .widget
            padding: 20px 0
</style>
